"use client"

import React, { useState, useRef, useEffect } from "react"

// Icons
const PetraIcon = () => (
  <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const QudraIcon = () => (
  <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const PharmaIcon = () => (
  <svg className="w-10 h-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
    <path d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104a24.301 24.301 0 014.5 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const Solutions = () => {
  const [selected, setSelected] = useState(null)
  const detailsRef = useRef(null)
  const sectionRef = useRef(null)

  const solutions = [
    {
      id: "PETRA",
      name: "PETRA",
      role: "Payer",
      icon: <PetraIcon />,
      description: "Automate, Optimize, and Control the Entire Claim Lifecycle Intelligent Claims Automation for Unbeatable Efficiency Move beyond manual reviews and legacy systems. PETRA delivers end-to-end automation powered by advanced rules and AI, giving Payer absolute control over the claim lifecycle. Slash administrative costs, dramatically reduce disputes, and transform your claims operation from a cost center into a strategic asset.",
     features: [
  {
    number: 1,
    title: "Medical & Coding Scrubber",
    description: "Leverage a comprehensive database with 55+ edit types to automatically validate claims against ICD, CPT, and CDT standards. Ensure clinical accuracy and compliance while reducing denials from the start."
  },
  {
    number: 2,
    title: "Custom Validation & Policy Engine",
    description: "Configure and automate your specific Terms of Benefits (TOBs), exclusions, and business rules. Apply validations at the policy, provider, or patient level to ensure every claim aligns perfectly with your internal policies."
  },
  {
    number: 3,
    title: "AI-Powered Claims Analysis",
    description: "Move from reactive to proactive management. Our AI layer detects fraud, identifies cost trends, and provides predictive insights through dashboards, enabling data-driven decision-making."
  },
  {
    number: 4,
    title: "Seamless Ecosystem Integration",
    description: "Built for your environment. PETRA integrates modularly with your existing core systems, enabling seamless data exchange and unified reporting without disruptive overhauls."
  },
]

    },
    {
      id: "QUDRA",
      name: "QUDRA",
      role: "Provider",
      icon: <QudraIcon />,
      description: "Healthcare Analytics & Fraud Detection Revenue Cycle Confidence, Powered by Precision QUDRA empowers healthcare providers with end-to-end claim precision powered by advanced rules and AI, giving you absolute confidence in every submission.",
     features: [
  {
    number: 1,
    title: "Medical & Coding Validation",
    description: "Ensure every claim is clinically and technically sound before submission. Our scrubber checks against global standards and provides real-time alerts for instant correction."
  },
  {
    number: 2,
    title: "Customizable Rules & Benefit Management",
    description: "Automatically adapt claim checks to specific payer policies and pre-authorization rules. Track patient history and financial limits to ensure accurate billing."
  },
  {
    number: 3,
    title: "AI Insights & Performance Analytics",
    description: "Gain deep visibility into your revenue cycle. Understand denial causes, identify claim patterns, and monitor coder performance through intelligent dashboards."
  },
  {
    number: 4,
    title: "Workflow Optimization",
    description: "Reduce administrative overhead. Automate repetitive validation tasks, streamline corrections, and drive first-pass acceptance rates to over 95%."
  },
]

    },
 {
  id: "PHARMA",
  name: "PHARMA",
  role: "Add-on Layer",
  icon: <PharmaIcon />,
  description: "Pharmaceutical Claims Management. Optimize your pharmaceutical claims lifecycle with AI driven pre approval workflows, clinical safety checks, benefit validations, and actionable analytics.",
  features: [
    {
      number: 1,
      title: "Medical Scrubbing Layer",
      description: "Automatically verify prescriptions against clinical guidelines and formularies using AI powered safety and compliance edits. Includes indication and contraindication edits, age, gender and dosage limits, drug drug interaction and duplicate therapy checks, and pregnancy and lactation safety validations."
    },
    {
      number: 2,
      title: "Benefit & Policy Checks",
      description: "Perform automated verifications using configurable business rules and real time policy validations, including network and eligibility checks, days’ supply and refill limits, drug exclusions, step therapy rules, generic substitution flags, lab result alerts, prior authorization identification, and fully customizable policy rules."
    },
    {
      number: 3,
      title: "Pre Approval Workflow Integration",
      description: "Streamline prior authorization processes with seamless PBM integration to reduce delays and denials."
    },
    {
      number: 4,
      title: "AI Insights & Analytics",
      description: "Use AI to analyze prescription data, identify trends, and optimize medication management by unlocking insights on drug utilization, cost trends, and prescribing patterns through advanced analytics and reporting."
    }
  ]
}


  ]

  const selectedSolution = solutions.find(s => s.id === selected)

  useEffect(() => {
    if (selected && detailsRef.current) {
      setTimeout(() => {
        const element = detailsRef.current
        if (element) {
          const yOffset = -100
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
          window.scrollTo({ top: y, behavior: "smooth" })
        }
      }, 100)
    }
  }, [selected])

  const handleCloseDetails = () => {
    setSelected(null)
    setTimeout(() => {
      if (sectionRef.current) {
        const yOffset = -100
        const y = sectionRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: "smooth" })
      }
    }, 100)
  }

  return (
    <section ref={sectionRef} className="relative bg-gradient-to-r from-[#020817] via-[#041E2F] to-[#000000] min-h-screen px-6 py-20 lg:py-32">
      <div className="max-w-[1600px] mx-auto">

        {/* Main Content: Text + Cards Side by Side */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 xl:gap-16 items-start mb-16">
          
          {/* Left: Header Section */}
          <div className="max-w-2xl">
            <h2 className="text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white mb-6 leading-tight">
              Our Innovative<br />Solutions
            </h2>
            
            <p className="text-xl lg:text-2xl font-semibold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent mb-8">
              AI-Powered Intelligence for Healthcare & Pharma
            </p>

            <p className="text-lg lg:text-xl text-gray-300 leading-relaxed">
In the complex world of healthcare operations, efficiency and accuracy are paramount. KAYAN delivers tailored, AI-driven solutions that transform critical processes—from claims management to compliance—reducing costs, accelerating revenue, and mitigating risk. We go beyond integration, offering multi-layered innovation that combines deep industry expertise with cutting-edge automation and analytics. Our mission is to empower providers and payers to achieve smarter operations, stronger compliance, and ultimately, better outcomes.            </p>
          </div>

          {/* Right: Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
          {solutions.map(sol => (
            <div
              key={sol.id}
              onClick={() => setSelected(prev => prev === sol.id ? null : sol.id)}
              className={`group relative bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm rounded-3xl p-6 cursor-pointer transition-all duration-300 border-2 hover:scale-[1.02] flex flex-col
              ${selected === sol.id 
                ? "border-cyan-400 shadow-2xl shadow-cyan-500/30" 
                : "border-white/10 hover:border-cyan-400/50 hover:shadow-xl hover:shadow-cyan-500/20"
              }`}
              style={{ aspectRatio: '1/1', width: '100%' }}
            >
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-cyan-400/20 to-blue-500/20 rounded-2xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                <div className="text-cyan-400">{sol.icon}</div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl font-bold text-white mb-2">{sol.name}</h3>
                <p className="text-sm text-cyan-300 font-medium mb-3">{sol.role}</p>
                <p className="text-sm text-gray-300 leading-relaxed line-clamp-4">
                  {sol.description}
                </p>
              </div>

              {/* CTA */}
              <div className="mt-4 flex items-center gap-2 text-cyan-400 font-semibold text-sm group-hover:gap-3 transition-all">
                <span>{selected === sol.id ? "Close Details" : "Read More"}</span>
                <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </div>

              {/* Selected Indicator */}
              {selected === sol.id && (
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-cyan-400 rounded-full flex items-center justify-center">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
                      ))}
          </div>
        </div>

        {/* Details Section */}
        {selectedSolution && (
          <div
            ref={detailsRef}
            className="bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm rounded-3xl p-10 lg:p-12 border-2 border-cyan-400 shadow-2xl shadow-cyan-500/30"
          >
            {/* Header */}
            <div className="flex justify-between items-start mb-10">
              <div>
                <h3 className="text-3xl lg:text-4xl font-bold text-white mb-2">{selectedSolution.name}</h3>
                <p className="text-lg text-cyan-300">{selectedSolution.role}</p>
              </div>
              <button 
                onClick={handleCloseDetails} 
                className="text-white hover:text-cyan-400 transition-colors p-2 hover:bg-white/10 rounded-lg"
              >
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <p className="text-lg text-gray-300 mb-12 leading-relaxed max-w-4xl">
              {selectedSolution.description}
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {selectedSolution.features.map((f) => (
                <div
                  key={f.number}
                  className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10 hover:border-cyan-400/50 transition-all hover:shadow-lg hover:shadow-cyan-500/10"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-xl flex items-center justify-center text-white font-bold text-xl mb-4">
                    {f.number}
                  </div>
                  <h4 className="text-white font-bold text-lg mb-3 leading-tight">{f.title}</h4>
                  <p className="text-gray-400 text-sm leading-relaxed">{f.description}</p>
                </div>
              ))}
            </div>
          </div>
        )}

      </div>
    </section>
  )
}

export default Solutions